import api from 'api'
import axios from 'axios'

import { setIdentity } from 'actions/branch'

import {sendNativeMessage } from 'util/native'

export function getProfile() {
  return dispatch => {
    return api.get('my_profile').then(resp => {
      const { profile } = resp.data
      dispatch(setIdentity(profile.guid))
      dispatch(getMessages())
      return dispatch({ type: 'SET_PROFILE', profile })
    })
  }
}

export function getMessages() {
  return dispatch => {
    return axios.get(process.env.REACT_APP_MESSAGES_URL).then(resp => {
      return dispatch({ type: 'SET_MESSAGES', messages: resp.data })
    })
  }
}

export function seenMessage(id) {
  return dispatch => {
    // TODO: Notify backend of seen
    return dispatch({ type: 'SEEN_MESSAGE', id })
  }
}

export function verifyPhone(code) {
  return dispatch => {
    return api.post('user/phone_number_confirmation', { phone_number_verification_code: code }).then(resp => {
      return dispatch(getProfile())
    })
  }
}

export function resendPhoneVerificationCode() {
  return dispatch => {
    return api.put('user/phone_number_confirmation')
  }
}

export function updatePhoneNumber(phone_number) {
  return dispatch => {
    return api.put('my_profile/phone_number', { phone_number }).then(resp => {
      return dispatch(getProfile())
    })
  }
}

export function updateProfile(data) {
  return dispatch => {
    return api.put('my_profile', data).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function addVehicle({ color, category }) {
  return dispatch => {
    return api.post('vehicles', { vehicle: { color, category }}).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function updateVehicle(id, { color, category }) {
  return dispatch => {
    return api.put(`vehicles/${id}`, { vehicle: { color, category }}).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function updateDriversLicense({ state, number, expiration_date }) {
  return dispatch => {
    return api.version(2).post('drivers_license', { state, number, expiration_date }).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function addBankAccount({ routing_number, account_number, account_type = 'checking', account_holder_type = 'personal' }) {
  return dispatch => {
    return api.post('profile/bank_accounts', { bank_account: {
      routing_number, account_number, account_type, account_holder_type,
    }}).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function updateBankAccount(id, { routing_number, account_number, account_type = 'checking', account_holder_type = 'personal' }) {
  return dispatch => {
    return api.patch(`profile/bank_accounts/${id}`, { bank_account: {
      routing_number, account_number, account_type, account_holder_type,
    }}).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function verifyBankAccount(id, deposits) {
  return dispatch => {
    return api.patch(`profile/bank_accounts/${id}/verify`, { deposits }).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function saveCreditCard(data) {
  return dispatch => {
    return api.post('profile/credit_cards', data).then(resp => {
      return dispatch(getProfile())
    })
  }
}

export function updatePhoto(file) {
  return dispatch => {
    const data = new FormData()
    data.append('file', file)
    return api.put('my_profile/avatar', data).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function addCert(type) {
  return dispatch => {
    return api.post('profile/certifications', { type }).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function agreeToTerms(payload) {
  return dispatch => {
    return api.version(3).post('profile/terms', payload).then(() => {
      sendNativeMessage({ type: 'TERMS_ACCEPTED' })
      return dispatch(getProfile())
    })
  }
}